import React from 'react';
import { st, classes } from '../TableActionCell.st.css';
import { HoverSlotProps } from '../TableActionCell.types';

const HoverSlot: React.FC<HoverSlotProps> = ({
  display,
  children,
  className,
  ...props
}) => (
  <span
    className={st(
      classes.hoverSlot,
      display ? (classes as Record<string, string>)[display] : undefined,
      className,
    )}
    data-display={display}
    {...props}
  >
    {children}
  </span>
);

export { HoverSlot };
